import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import firebase from 'firebase';
import userStore from './store/UserStore';
import SkillsPage from './pages/SkillsPage';
import SkillPage from './pages/SkillPage';
import UserPage from './pages/userPage';
import './App.css';

class App extends Component {
  constructor(props){
    super(props);
    this.state = {
      'currentUser': '',
      'users':{}
    };
  }

  componentDidMount() {
     firebase.auth().onAuthStateChanged((user) => {
          if (user) {
              userStore.login();
              let rando = Math.floor(Math.random()*100000);
              let old = window.localStorage.getItem('tempid');
              if (!old) {
                window.localStorage.setItem('tempid', rando);
              } else {
                rando = old;
              }

              userStore.setUserInfo(user.email || `demoUser${rando}@gmail.com`, user.displayName || `Demo User ${rando}`, user.photoURL || '', user.uid || `${rando}` );
              this.setState({...this.state, currentUser: user.displayName});
              console.log('testing');
              if (!!this.state.users && !this.state.users.hasOwnProperty(user.uid)){
                  console.log('setting new user');
                  let newRef = firebase.database().ref(`users`).child(user.uid);
                  newRef.update({name: user.displayName, email: user.email, photo: user.photoURL });
              }
          } else {
              userStore.logout();
          }
      })
      firebase.database().ref(`users`).on('value', snapshot => {
              this.setState({
                  users: snapshot.val()
              });
              userStore.setUsers(snapshot.val());
          });

  }

  render() {
    return (
      <div className="App">
      <Router>
        <Switch>
          <Route exact path='/' component={SkillsPage} user={this.state.currentUser}/>
          <Route path='/skill/:sid' component={SkillPage} user={this.state.currentUser}/>
          <Route path='/*' component={SkillsPage} user={this.state.currentUser}/>
        </Switch>
      </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js